var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#CCD2E3",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0864 16.069L9.384 14.707C9.13517 15.4253 9 16.1966 9 16.9994C9 20.8654 12.134 23.9994 16 23.9994C19.866 23.9994 23 20.8654 23 16.9994C23 16.1966 22.8648 15.4253 22.616 14.707L20.9136 16.069C20.9703 16.3705 21 16.6815 21 16.9994C21 19.7609 18.7614 21.9994 16 21.9994C13.2386 21.9994 11 19.7609 11 16.9994C11 16.6815 11.0297 16.3705 11.0864 16.069Z",
    fill: "#CCD2E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7L15.3753 6.21913L16 5.71937L16.6247 6.21913L16 7ZM17 16C17 16.5523 16.5523 17 16 17C15.4477 17 15 16.5523 15 16L17 16ZM10.3753 10.2191L15.3753 6.21913L16.6247 7.78087L11.6247 11.7809L10.3753 10.2191ZM16.6247 6.21913L21.6247 10.2191L20.3753 11.7809L15.3753 7.78087L16.6247 6.21913ZM17 7L17 16L15 16L15 7L17 7Z",
    fill: "#CCD2E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.90d339aa.svg";
export { ForwardRef as ReactComponent };